export const isOwnRequest = (item: any): boolean => {
  if (!item && item !== 0) return false;

  const myEmpId =
    localStorage.getItem("empId") ||
    localStorage.getItem("employeeId") ||
    localStorage.getItem("employee_id") ||
    localStorage.getItem("userId") ||
    localStorage.getItem("user_id");

  const myPosId =
    localStorage.getItem("positionId") ||
    localStorage.getItem("position_id");

  if (typeof item === "string" || typeof item === "number") {
    if (myEmpId && String(myEmpId) === String(item)) return true;
    if (myPosId && String(myPosId) === String(item)) return true;
    return false;
  }

  const itemEmpId =
    item.EmployeeId ??
    item.employee_id ??
    item.EmpId ??
    item.emp_id ??
    item.UserId ??
    item.user_id ??
    item.CreatedBy ??
    item.created_by ??
    item.RequestedBy ??
    item.requested_by ??
    item.employeeId ??
    item.userId;

  const itemPosId =
    item.PositionId ??
    item.position_id ??
    item.CreatedByPosition ??
    item.created_by_position ??
    item.positionId;

  if (myEmpId && itemEmpId !== undefined && itemEmpId !== null && String(myEmpId) === String(itemEmpId)) {
    return true;
  }

  if (myPosId && itemPosId !== undefined && itemPosId !== null && String(myPosId) === String(itemPosId)) {
    return true;
  }

  return false;
};
